module.exports = __webpack_public_path__ + "img/1.b33d93c8.jpg";